import styled from '@emotion/styled/macro'
import { hideVisually } from 'polished'

const VisuallyHidden = styled.span`
  ${hideVisually};
`

export default VisuallyHidden
